import { defineMessages } from "react-intl";

import { ReservationType } from "@/features/bookings/types/types";

export const reservationTypesLabels = defineMessages({
  [ReservationType.PAST]: {
    defaultMessage: "Past",
    description: "bookings.past",
  },
  [ReservationType.UPCOMING]: {
    defaultMessage: "Upcoming",
    description: "bookings.upcoming",
  },
  [ReservationType.REFUNDED]: {
    defaultMessage: "Cancelled",
    description: "bookings.cancelled",
  },
});
